import api from '../../api'
import {
  GET_CHARGETYPE_LIST_SUCCESS,
  GET_CHARGETYPE_LIST_FAILURE,
  GET_CHARGETYPE_FAILURE,
  GET_CHARGETYPE_SUCCESS,
  UPDATE_CHARGETYPE_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {

  
  getChargeTypeList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getChargeTypeList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
        return commit(GET_CHARGETYPE_LIST_FAILURE)
        return reject(response.body.$error)

      }
      commit(GET_CHARGETYPE_LIST_SUCCESS, {
        chargetypeList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_CHARGETYPE_LIST_FAILURE)
      return reject(response.body.$error)

    })
  })
  },
 
  cleanChargeTypeList({commit}) {
    return commit(GET_CHARGETYPE_LIST_FAILURE)
  },
  
  getChargeType({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getChargeType(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_CHARGETYPE_FAILURE);
            reject();
          }
          commit(GET_CHARGETYPE_SUCCESS, {
            chargetype: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_CHARGETYPE_FAILURE);
          reject();
        })
    })
  },
 
  
  updateChargeType({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "name",
        "abbreviation"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateChargeType(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },
  createChargeType({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createChargeType(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },
  
  
 
  deleteChargeType({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteChargeType(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  
  
};

const mutations = {

  [UPDATE_CHARGETYPE_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.chargetype));
  },
  [GET_CHARGETYPE_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_CHARGETYPE_LIST_SUCCESS](state, action) {
    state.list = action.chargetypeList;
    state.listUpdated = new Date();
  },
  [GET_CHARGETYPE_FAILURE](state) {
    state.selected = null
  },
  [GET_CHARGETYPE_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.chargetype));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/chargetype.js